export default __webpack_public_path__ + "static/p4-e6e32b5b5caf0275d4a93360cd5e9864.jpg";